"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[29678],{

/***/ 89999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ HumbergerButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71577);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _hoc_withSpacing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97214);
/* eslint-disable react/jsx-props-no-spreading */ 



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      color: ",
        ";\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      color: ",
        ";\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        ,\n        :hover {\n          background: ",
        ";\n          color: ",
        ";\n        }\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border: none;\n    border-bottom: 1px solid ",
        ";\n    :hover,\n    :focus {\n      border-color: ",
        ";\n      color: ",
        ";\n    }\n\n    ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border-radius: ",
        ";\n    height: ",
        ";\n    margin: ",
        ";\n    padding: ",
        ";\n    \n    ::after{\n      content: unset;\n    }\n    \n    ",
        ";\n    border : ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background: ",
        ";\n      border-left: 1px solid ",
        ';\n      position: relative;\n      ::after {\n        content: "";\n        position: absolute;\n        bottom: 0;\n        width: 100%;\n        height: 2px;\n        background: ',
        ";\n      }\n      span:nth-child(1) {\n        transform: rotate(45deg);\n        position: relative;\n        top: 5px;\n      }\n      span:nth-child(2) {\n        display: none;\n      }\n      span:nth-child(3) {\n        transform: rotate(-45deg);\n        position: relative;\n        bottom: 0;\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n  padding: 10px;\n  \n  span {\n    display: block;\n    height: 1px;\n    width: 16px;\n    background: ",
        ";\n    margin: 4px auto 0;\n    transition : 0.3s;\n  }\n  \n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}






var buttonType = {
    sunsetOrange: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].sunsetOrange */ .Z.sunsetOrange),
    highempahis: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis),
    defaultHoverable: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary),
    default: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro),
    primary: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary),
    widget: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject6(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis, function(param) {
        var active = param.active;
        return active && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject5(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].aliceBlue */ .Z.aliceBlue, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary);
    })
};
var ButtonCustom = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.memo((0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "round",
            "active",
            "borderLess"
        ].includes(prop);
    }
}).attrs(function(props) {
    return {
        height: props.height || "auto",
        type: props.type || "default",
        round: props.round,
        active: props.active,
        borderLess: props.borderLess,
        margin: props.margin || "0 !important",
        padding: props.padding || "4px 15px"
    };
}).withConfig({
    componentId: "sc-6d94ba47-0"
})(_templateObject7(), function(param) {
    var round = param.round;
    return round ? "2px" : "0px";
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var type = param.type;
    return buttonType[type];
}, function(param) {
    var borderLess = param.borderLess;
    return borderLess && "none";
}));
var HumbergerButtonComp = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    shouldForwardProp: function(props) {
        return ![
            "active"
        ].includes(props);
    }
}).attrs(function(props) {
    return {
        active: props.active
    };
}).withConfig({
    componentId: "sc-6d94ba47-1"
})(_templateObject9(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].dimgray */ .Z.dimgray, function(param) {
    var active = param.active;
    return active && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject8(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light);
});
var HumbergerButton = function(_param) /*#__PURE__*/ {
    var className = _param.className, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(HumbergerButtonComp, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        className: className
    }, otherProps), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {})
        ]
    }));
};

/* harmony default export */ __webpack_exports__["Z"] = ((0,_hoc_withSpacing__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ButtonCustom));


/***/ }),

/***/ 61166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79931);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        .ant-table-thead > tr > th,\n        .ant-table-tbody > tr > td {\n          border: none;\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-table-cell {\n      padding: 0 !important;\n    }\n    .ant-table-thead > tr > th,\n    .ant-table-tbody > tr > td {\n      border-bottom: 1px solid ",
        ";\n    }\n\n    .ant-table-tbody > tr {\n      position: relative;\n    }\n    .ant-table-tbody > tr:hover > td {\n      background: ",
        ";\n    }\n    .ant-pagination-item-active{\n      border-color : ",
        ";\n    }\n    .ant-pagination-item-active a,\n    .ant-pagination-item:focus a, \n    .ant-pagination-item:hover a{\n      color : ",
        "\n    }\n\n    ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    shouldForwardProp: function(props) {
        return ![
            "borderless"
        ].includes(props);
    }
}).attrs(function(props) {
    return {
        borderless: props.borderless
    };
}).withConfig({
    componentId: "sc-43a24ac8-0"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].aliceBlue */ .Z.aliceBlue, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].aliceBlue */ .Z.aliceBlue, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, function(param) {
    var borderless = param.borderless;
    return borderless && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
}));


/***/ }),

/***/ 8150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56266);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-71cb950b-0"
})(_templateObject()));


/***/ }),

/***/ 15740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RegisterTradingModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(579);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37213);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29658);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48085);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38305);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41110);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70175);











function RegisterTradingModal(param) {
    var visible = param.visible, onClose = param.onClose;
    var closeModal = (0,_store__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(state) {
        return state.closeModal;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), loading = ref[0], setloading = ref[1];
    var handleClose = function() {
        closeModal();
        if (onClose) {
            onClose();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .AuthModalContainer */ .EB, {
        "data-cy": "register-trading-modal",
        visible: visible,
        centered: true,
        width: 751,
        onCancel: handleClose,
        zIndex: 1050,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .CarouselContainer */ .am, {
                    justify: "center",
                    align: "center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_7__/* .Carousel */ .lr, {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .RegisterInfoContainer */ .un, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            condition: loading,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_7__/* .AuthModalLoading */ .FL, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            condition: !loading,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    family: "bold",
                                    size: "24px",
                                    mb: "8px",
                                    children: "Mulai Investasi di Saham bersama Stockbit"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    mb: "40px",
                                    children: "Download aplikasi Stockbit untuk membuka akun trading dan mulai perjalanan investasimu dengan lebih mudah. Scan QR Code di bawah ini."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    justify: "space-between",
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            direction: "column",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    target: "_blank",
                                                    href: constants_api__WEBPACK_IMPORTED_MODULE_4__/* .GOOGLE_PLAY_URL */ .VE,
                                                    rel: "noopener noreferrer",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                        alt: "android",
                                                        src: "/images/google-play.png",
                                                        style: {
                                                            height: "40px",
                                                            marginBottom: "24px"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    target: "_blank",
                                                    href: constants_api__WEBPACK_IMPORTED_MODULE_4__/* .APP_STORE_URL */ .l5,
                                                    rel: "noopener noreferrer",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                        alt: "iOS",
                                                        src: "/images/app-store.png",
                                                        style: {
                                                            height: "40px"
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .RegisterInfoDivider */ .kp, {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            src: "/img/stockbit-qr.svg",
                                            alt: "stockbit app qr code"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    justify: "space-between",
                                    align: "center",
                                    mt: "40px",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                            size: "16px",
                                            color: "#858585",
                                            children: "Or Switch Platform"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_7__/* .VirtualTradingButton */ .qW, {
                                            title: "Virtual Trading",
                                            type: _types__WEBPACK_IMPORTED_MODULE_8__/* .AuthModalType.REGISTER */ .O.REGISTER,
                                            setLoading: setloading
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 48085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EB": function() { return /* binding */ AuthModalContainer; },
/* harmony export */   "GX": function() { return /* binding */ ButtonSubmit; },
/* harmony export */   "Ue": function() { return /* binding */ LoginTradingModalContainer; },
/* harmony export */   "X4": function() { return /* binding */ ProgressRejectedAuthModalContainer; },
/* harmony export */   "am": function() { return /* binding */ CarouselContainer; },
/* harmony export */   "kp": function() { return /* binding */ RegisterInfoDivider; },
/* harmony export */   "rG": function() { return /* binding */ LoginInfoDivider; },
/* harmony export */   "un": function() { return /* binding */ RegisterInfoContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16368);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    border-radius: 3px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 40px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 40px 40px 20px 40px;\n  }\n\n  /* Fade In & Scale Up Animation */\n  @keyframes fadeScaleIn {\n    from {\n      opacity: 0;\n      transform: scale(0.8);\n    }\n    to {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n\n  /* Fade Out & Scale Down Animation */\n  @keyframes fadeScaleOut {\n    from {\n      opacity: 1;\n      transform: scale(1);\n    }\n    to {\n      opacity: 0;\n      transform: scale(0.8);\n    }\n  }\n\n  /* Ant Design Modal Animation Overrides */\n  .custom-modal-enter {\n    animation: fadeScaleIn 0.5s ease-out;\n  }\n\n  .custom-modal-leave {\n    animation: fadeScaleOut 0.5s ease-in;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 360px;\n  min-height: 492px;\n  background-color: #5dcbad26;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 391px;\n  padding: 40px 32px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 1px;\n  height: 144px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 185px;\n  height: 1px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 160px;\n  height: 40px;\n  gap: 10px;\n  padding-top: 10px;\n  padding-right: 20px;\n  padding-bottom: 10px;\n  padding-left: 20px;\n  border-radius: 4px;\n  background: #00AB6B;\n  border: none;\n  color: #FFF;\n  font-family: var(--font-bold);\n  cursor: pointer;\n\n  :disabled {\n    background: #CCEEE1;\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var AuthModalContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ab604be6-0"
})(_templateObject());
var ProgressRejectedAuthModalContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(AuthModalContainer).withConfig({
    componentId: "sc-ab604be6-1"
})(_templateObject1());
var LoginTradingModalContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(AuthModalContainer).withConfig({
    componentId: "sc-ab604be6-2"
})(_templateObject2());
var CarouselContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ab604be6-3"
})(_templateObject3());
var RegisterInfoContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ab604be6-4"
})(_templateObject4());
var RegisterInfoDivider = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ab604be6-5"
})(_templateObject5(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].downgray */ .Z.downgray);
var LoginInfoDivider = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ab604be6-6"
})(_templateObject6(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].downgray */ .Z.downgray);
var ButtonSubmit = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-ab604be6-7"
})(_templateObject7());


/***/ }),

/***/ 89994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ global_GlobalModalManager; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/global/Securities/stores/useTransactionFormStore.ts
var useTransactionFormStore = __webpack_require__(52870);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/typings/transactionForm.ts
var transactionForm = __webpack_require__(93134);
// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var store = __webpack_require__(70362);
// EXTERNAL MODULE: ./src/global/Securities/stores/usePortfolioDetailStore.ts + 1 modules
var usePortfolioDetailStore = __webpack_require__(98976);
// EXTERNAL MODULE: ./src/global/Securities/websocket/usePortfolio/index.ts + 4 modules
var usePortfolio = __webpack_require__(77596);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/global/Securities/websocket/store/securities.store.tsx
var securities_store = __webpack_require__(28840);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/store.ts
var RunningTrade_store = __webpack_require__(78970);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/types.ts
var types = __webpack_require__(7365);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./src/global/Datafeed/store/runningTrade/index.ts + 2 modules
var runningTrade = __webpack_require__(11453);
// EXTERNAL MODULE: ./src/lib/flipt/hooks/index.ts + 1 modules
var hooks = __webpack_require__(62514);
// EXTERNAL MODULE: ./src/lib/flipt/constants/flagKeys.ts
var flagKeys = __webpack_require__(34540);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/index.tsx + 25 modules
var RunningTrade = __webpack_require__(41234);
// EXTERNAL MODULE: ./src/global/Modal/BaseModal/index.tsx
var BaseModal = __webpack_require__(16981);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/fast-order/FastOrderModal/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-modal-content {\n    height: 90vh;\n    border-radius: 4px;\n  }\n\n  & .ant-modal-body {\n    padding: 0;\n    border-radius: 4px;\n    overflow: hidden;\n\n    height: 100vh;\n    max-height: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100% !important;\n  width: 100%;\n  overflow: hidden;\n\n  & > div {\n    height: 100% !important;\n\n    & > div:last-of-type {\n      height: 100% !important;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Modal = (0,styled_components_browser_esm/* default */.ZP)(BaseModal/* default */.Z).withConfig({
    componentId: "sc-d92a8940-0"
})(_templateObject());
var FastRunningTrade = (0,styled_components_browser_esm/* default */.ZP)(RunningTrade["default"]).withConfig({
    componentId: "sc-d92a8940-1"
})(_templateObject1());

// EXTERNAL MODULE: ./src/features/fast-order/FastOrderSkeleton/styled.ts + 2 modules
var styled = __webpack_require__(72294);
;// CONCATENATED MODULE: ./src/features/fast-order/FastOrderSkeleton/Layout.tsx



var Layout = function(param) {
    var id = param.id, header = param.header, leftSection = param.leftSection, rightSection = param.rightSection;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Container */.W2, {
        id: id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* HeaderWrapper */.Pz, {
                children: header
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ContentGrid */.uG, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* LeftSection */.Bx, {
                        children: leftSection
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* RightSection */.lV, {
                        children: rightSection
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FastOrderSkeleton_Layout = (/*#__PURE__*/(0,react.memo)(Layout));

// EXTERNAL MODULE: ./src/features/fast-order/Flex/index.ts + 1 modules
var Flex = __webpack_require__(55524);
;// CONCATENATED MODULE: ./src/features/fast-order/FastOrderSkeleton/index.tsx




var SkeletonHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
        px: 16,
        py: 12,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
            width: 120,
            height: 30
        })
    });
};
var LeftSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
        direction: "column",
        height: "100%",
        px: 16,
        py: 12,
        gap: 14,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                width: 106,
                height: 30
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                direction: "column",
                gap: 14,
                position: "relative",
                height: "100%",
                style: {
                    overflow: "auto"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    direction: "column",
                    gap: 14,
                    position: "absolute",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PortfolioContainer */.AX, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                    children: new Array(3).fill("").map(function(_, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                            direction: "column",
                                            gap: 6,
                                            width: "100%",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                                    width: 120,
                                                    height: 12
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                                    width: 80,
                                                    height: 12
                                                })
                                            ]
                                        }, i.toString());
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Divider */.iz, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                    align: "center",
                                    gap: 12,
                                    height: 28,
                                    mb: 40,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                            width: 80,
                                            height: 12
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                            variant: "outline",
                                            width: 148,
                                            height: "100%"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                            gap: 8,
                                            children: new Array(3).fill("").map(function(_, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                                    variant: "outline",
                                                    width: 80,
                                                    height: 28,
                                                    rounded: true
                                                }, i.toString());
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Table */.iA, {
                            children: new Array(21).fill("").map(function(_, rowIdx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TableRow */.SC, {
                                    children: new Array(5).fill("").map(function(__, colIdx) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TableCell */.pj, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                                height: 16
                                            })
                                        }, "".concat(rowIdx.toString(), "-").concat(colIdx.toString()));
                                    })
                                }, rowIdx.toString());
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                gap: 16,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                        variant: "outline",
                        width: "100%",
                        height: 32
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                        variant: "outline",
                        width: "100%",
                        height: 32
                    })
                ]
            })
        ]
    });
};
var RightSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
        direction: "column",
        width: "100%",
        height: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                direction: "column",
                px: 16,
                py: 12,
                mb: 22,
                gap: 12,
                children: Array.from({
                    length: 3
                }).map(function(_, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        width: "100%",
                        justify: "space-between",
                        gap: 30,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                width: "100%",
                                justify: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                        width: 40,
                                        height: 12
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                        width: 60,
                                        height: 12
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                width: "100%",
                                justify: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                        width: 40,
                                        height: 12
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                        width: 60,
                                        height: 12
                                    })
                                ]
                            })
                        ]
                    }, "ohlc-".concat(idx.toString()));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ThickDivider */.Zh, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                direction: "column",
                width: "100%",
                py: 12,
                gap: 12,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        width: "100%",
                        justify: "flex-end",
                        gap: 8,
                        px: 16,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* BorderedButton */.aX, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* BorderedButton */.aX, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        direction: "column",
                        px: 8,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Divider */.iz, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                width: "100%",
                                justify: "space-between",
                                children: Array.from({
                                    length: 5
                                }).map(function(_, idx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                        px: 8,
                                        py: 10,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                            width: 40,
                                            height: 12
                                        })
                                    }, "th-".concat(idx.toString()));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Divider */.iz, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                direction: "column",
                                gap: 10,
                                py: 10,
                                children: Array.from({
                                    length: 4
                                }).map(function() {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Skeleton */.Od, {
                                        width: "100%",
                                        height: 12
                                    });
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var FastOrderSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FastOrderSkeleton_Layout, {
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonHeader, {}),
        leftSection: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftSection, {}),
        rightSection: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightSection, {})
    });
};
/* harmony default export */ var fast_order_FastOrderSkeleton = (FastOrderSkeleton);

// EXTERNAL MODULE: ./src/features/fast-order/stores/useFastOrderStore.ts
var useFastOrderStore = __webpack_require__(5562);
// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/liveprice.store.types.ts
var liveprice_store_types = __webpack_require__(27934);
// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/orderbook.store.types.ts
var orderbook_store_types = __webpack_require__(52781);
// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/useOrderbookReceiver.ts
var useOrderbookReceiver = __webpack_require__(49816);
// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/useOrderbookSender.ts
var useOrderbookSender = __webpack_require__(64579);
;// CONCATENATED MODULE: ./src/global/Datafeed/UseOrderbook/useRawOrderbook.ts


var useRawOrderbook = function(symbols, stateKey, actionKey, onMessage) {
    (0,useOrderbookSender/* useOrderbookSender */.J)(stateKey, symbols);
    (0,useOrderbookReceiver/* useRawOrderbookReceiver */.H)(symbols, actionKey, onMessage);
};

// EXTERNAL MODULE: ./src/global/Datafeed/useBestBidOffer.ts
var useBestBidOffer = __webpack_require__(11562);
// EXTERNAL MODULE: ./src/global/Datafeed/useOrderbookIEPIEV.ts
var useOrderbookIEPIEV = __webpack_require__(28398);
// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/useLivePriceSender.ts
var useLivePriceSender = __webpack_require__(35320);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/global/Datafeed/useDatafeedMessageEffect.ts
var useDatafeedMessageEffect = __webpack_require__(49696);
;// CONCATENATED MODULE: ./src/global/Datafeed/UseLivePrice/useRawLivePriceReceiver.ts




var useRawLivePriceReceiver = function(symbols, key, onMessage) {
    var stringSymbols = symbols.join();
    var handleReceiveMessage = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(message) {
            var liveprice;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        liveprice = (message || {}).liveprice;
                        if (liveprice && stringSymbols.split(",").includes(liveprice.stockCode)) {
                            onMessage(liveprice);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(message) {
            return _ref.apply(this, arguments);
        };
    }(), [
        stringSymbols,
        onMessage
    ]);
    // Nats Socket Receiver
    (0,useDatafeedMessageEffect/* default */.Z)("liveprice", "".concat(key, ":").concat(symbols.join()), handleReceiveMessage);
};

;// CONCATENATED MODULE: ./src/global/Datafeed/UseLivePrice/useRawLivePrice.ts


var useRawLivePrice = function(symbols, stateKey, actionKey, onMessage) {
    (0,useLivePriceSender/* useLivePriceSender */.O)(stateKey, symbols);
    useRawLivePriceReceiver(symbols, actionKey, onMessage);
};

;// CONCATENATED MODULE: ./src/features/fast-order/hooks/useFastOrderDatafeed.ts







var useFastOrderDatafeed = function(symbol) {
    var ref = (0,react.useState)(), orderbook = ref[0], setOrderbook = ref[1];
    var ref1 = (0,react.useState)(), livePrice = ref1[0], setLivePrice = ref1[1];
    var ref2 = (0,react.useState)(), iepiev = ref2[0], setIepIev = ref2[1];
    var ref3 = (0,react.useState)(), bestBidOffer = ref3[0], setBestBidOffer = ref3[1];
    useRawOrderbook([
        symbol
    ], orderbook_store_types/* OrderbookSymbolsKeyEnum.FAST_ORDER */.E.FAST_ORDER, "fast_order", setOrderbook);
    useRawLivePrice([
        symbol
    ], liveprice_store_types/* LivePriceSymbolsKeyEnum.FAST_ORDER */.j.FAST_ORDER, "fast_order", setLivePrice);
    (0,useOrderbookIEPIEV/* useOrderbookIEPIEV */.Jj)([
        symbol
    ], "fast_order", setIepIev);
    (0,useBestBidOffer/* default */.ZP)([
        symbol
    ], "fast_order", setBestBidOffer);
    return {
        orderbook: orderbook,
        livePrice: livePrice,
        iepiev: iepiev,
        bestBidOffer: bestBidOffer
    };
};
/* harmony default export */ var hooks_useFastOrderDatafeed = (useFastOrderDatafeed);

;// CONCATENATED MODULE: ./src/features/fast-order/FastOrderModal/index.tsx

























var FastOrderFederation = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 72311).then(__webpack_require__.t.bind(__webpack_require__, 72311, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72311)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(fast_order_FastOrderSkeleton, {});
    }
});
var FastOrderRunningTrade = function(param) {
    var hideCode = param.hideCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FastRunningTrade, {
        runningTradeKey: "widget",
        minDataLength: 50,
        allowInitialData: true,
        hideCode: hideCode,
        hideStockFilter: true,
        hideHeader: true,
        playAlignRight: true,
        fullWidth: true,
        isPro: true,
        isVolumeColor: true
    });
};
var FastOrderModal = function(_param) {
    var switchFormConfig = _param.switchFormConfig, props = (0,_object_without_properties/* default */.Z)(_param, [
        "switchFormConfig"
    ]);
    var onCancel = props.onCancel;
    var isDuplicateBidofferEnabled = (0,hooks/* useFliptBoolean */.v)(flagKeys/* FeatureFlagKeys.FAST_ORDER_DUPLICATE_BIDOFFER */.O.FAST_ORDER_DUPLICATE_BIDOFFER);
    var showClassicModal = (0,store/* default */.Z)(function(s) {
        return s.showModal;
    });
    var isSecuritiesSocketOnline = (0,securities_store/* useSecuritiesStore */.$A)(function(s) {
        return s.isSocketOnline;
    });
    var ref = (0,_sliced_to_array/* default */.Z)((0,useFastOrderStore/* default */.Z)(function(s) {
        return [
            s.symbol,
            s.setSymbol
        ];
    }), 2), symbol = ref[0], setSymbol = ref[1];
    var setFormType = (0,useTransactionFormStore/* default */.Z)(function(s) {
        return s.setFormType;
    });
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,tradingData/* default */.Z)(function(s) {
        var ref, ref1;
        return [
            (ref = s.portfolio) === null || ref === void 0 ? void 0 : ref.data,
            (ref1 = s.orderHistory) === null || ref1 === void 0 ? void 0 : ref1.data,
            s.getOrderHistory, 
        ];
    }), 3), portfolio = ref1[0], orderList = ref1[1], getOrderHistory = ref1[2];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,usePortfolioDetailStore/* default */.Z)(function(s) {
        return [
            s.data,
            s.setCurrentSymbol, 
        ];
    }), 2), portfolioDetail = ref2[0], setCurrentSymbol = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,RunningTrade_store/* useFilterStore */.r)(function(s) {
        return [
            s.onApplyStockFilter
        ];
    }), 1), onApplyStockFilter = ref3[0];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,runningTrade/* useRunningTradeStore */.C)(function(s) {
        return [
            s.clearData
        ];
    }), 1), clearData = ref4[0];
    var ref5 = hooks_useFastOrderDatafeed(props.visible ? symbol : ""), wsOrderbook = ref5.orderbook, bestBidOffer = ref5.bestBidOffer, iepiev = ref5.iepiev, livePrice = ref5.livePrice;
    var router = (0,next_router.useRouter)();
    var isAllowUnsubscribe = router.pathname !== "/securities/[category]" && router.pathname !== "/symbol/[symbol]/chartbit";
    (0,usePortfolio/* default */.Z)(isAllowUnsubscribe);
    var handleFormTypeChange = function(value) {
        setFormType(value);
        showClassicModal((0,_object_spread/* default */.Z)({
            symbol: symbol,
            orderType: trading/* ORDER_TYPE.BUY */.Jm.BUY
        }, switchFormConfig));
        props.onCancel();
    };
    var handleEmittenChange = (0,react.useCallback)(function(newSymbol) {
        setSymbol(newSymbol);
        setCurrentSymbol(newSymbol);
        onApplyStockFilter({
            type: newSymbol ? types/* StockFilterTypeEnum.Custom */.d.Custom : types/* StockFilterTypeEnum.AllStock */.d.AllStock,
            selected: newSymbol ? [
                newSymbol
            ] : []
        });
        clearData("widget");
    }, [
        setSymbol
    ]);
    var handleModalCancel = function() {
        onApplyStockFilter({
            type: types/* StockFilterTypeEnum.AllStock */.d.AllStock,
            selected: []
        });
        clearData("widget");
        props.onCancel();
    };
    (0,react.useEffect)(function() {
        if (props.visible) getOrderHistory(true);
    }, [
        props.visible
    ]);
    (0,react.useEffect)(function() {
        var handleMessageCompass = function(event) {
            var customEvent = event;
            if (customEvent.detail.name === "securities-deposit") {
                router.push("/securities/deposit");
                props.onCancel();
            }
        };
        window.addEventListener("compass-global", handleMessageCompass);
        return function() {
            window.removeEventListener("compass-global", handleMessageCompass);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 1096,
        hideHeader: true
    }, props), {
        onCancel: handleModalCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FastOrderFederation, {
            formType: transactionForm/* TransactionFormType.FastOrder */.b.FastOrder,
            defaultSymbol: symbol,
            onFormTypeChange: handleFormTypeChange,
            onEmittenChange: handleEmittenChange,
            onClose: onCancel,
            rightSection: /*#__PURE__*/ (0,jsx_runtime.jsx)(FastOrderRunningTrade, {
                hideCode: !!symbol
            }),
            orderList: orderList,
            portfolio: portfolio,
            portfolioDetail: portfolioDetail,
            wsOrderbook: wsOrderbook,
            bestBidOffer: bestBidOffer,
            iepiev: iepiev,
            livePrice: livePrice,
            securitiesSocketOnline: isSecuritiesSocketOnline,
            disableDuplicateHandler: !isDuplicateBidofferEnabled
        })
    }));
};
/* harmony default export */ var fast_order_FastOrderModal = (/*#__PURE__*/(0,react.memo)(FastOrderModal));

// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/index.js + 5 modules
var common = __webpack_require__(48308);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/RegisterTradingModal.tsx
var RegisterTradingModal = __webpack_require__(15740);
// EXTERNAL MODULE: ./src/global/Common/If.tsx
var If = __webpack_require__(3897);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
;// CONCATENATED MODULE: ./src/features/chat/Modals/ChatLimitModal.tsx









var ChatLimitModal = function(props) {
    var ref = (0,react.useState)(false), openSekuritas = ref[0], setOpenSekuritas = ref[1];
    var visible = props.visible, onCancel = props.onCancel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: visible && !openSekuritas,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Modal */.u_, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    width: 400,
                    visible: visible && !openSekuritas,
                    hideHeader: true
                }, props), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* Flex */.kC, {
                        direction: "column",
                        padding: "60px 20px 20px 20px",
                        style: {
                            gap: 24
                        },
                        align: "center",
                        justify: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/illustration/chat-limit.svg",
                                width: 160,
                                height: 120
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* Flex */.kC, {
                                direction: "column",
                                style: {
                                    gap: 12
                                },
                                align: "center",
                                justify: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Text */.xv, {
                                        size: "17px",
                                        weight: "700",
                                        align: "center",
                                        color: color/* default.highempahis */.Z.highempahis,
                                        children: "Chat Limit Reached"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Text */.xv, {
                                        align: "center",
                                        size: "14px",
                                        weight: "400",
                                        color: "#858585",
                                        children: "You’ve Reached Your Daily Limit. Wait until tomorrow to start a new chat or open a Stockbit Sekuritas Account to remove your limit."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                                width: "100%",
                                color: "green",
                                type: "primary",
                                style: {
                                    padding: 12,
                                    borderRadius: 3
                                },
                                onClick: function() {
                                    return setOpenSekuritas(true);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Text */.xv, {
                                    weight: "700",
                                    color: "#fff",
                                    size: "14px",
                                    children: "Open Stockbit Sekuritas Account"
                                })
                            })
                        ]
                    })
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: visible && openSekuritas,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterTradingModal/* default */.Z, {
                    visible: visible && openSekuritas,
                    onClose: onCancel
                })
            })
        ]
    });
};
/* harmony default export */ var Modals_ChatLimitModal = (ChatLimitModal);

// EXTERNAL MODULE: ./src/global/GlobalModalManager/types/index.ts
var GlobalModalManager_types = __webpack_require__(30682);
;// CONCATENATED MODULE: ./src/global/GlobalModalManager/modalComponentList.ts




var _obj;
var modalComponentList = (_obj = {}, (0,_define_property/* default */.Z)(_obj, GlobalModalManager_types/* GlobalModalType.FastOrder */.C.FastOrder, fast_order_FastOrderModal), (0,_define_property/* default */.Z)(_obj, GlobalModalManager_types/* GlobalModalType.ChatLimit */.C.ChatLimit, Modals_ChatLimitModal), _obj);

// EXTERNAL MODULE: ./src/global/GlobalModalManager/stores/useGlobalModalStore.ts
var useGlobalModalStore = __webpack_require__(14467);
;// CONCATENATED MODULE: ./src/global/GlobalModalManager/index.tsx






var GlobalModalManager = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useGlobalModalStore/* default */.Z)(function(s) {
        return [
            s.activeModal,
            s.modalProps,
            s.setActiveModal, 
        ];
    }), 3), activeModal = ref[0], modalProps = ref[1], setActiveModal = ref[2];
    var getActiveModal = (0,react.useCallback)(function(modalType) {
        return modalType === activeModal;
    }, [
        activeModal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: Object.entries(modalComponentList).map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], ModalComponent = _param[1];
            var isActive = getActiveModal(key);
            return isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalComponent, (0,_object_spread/* default */.Z)({
                visible: isActive,
                onCancel: function() {
                    setActiveModal();
                }
            }, modalProps[key]), key);
        })
    });
};
/* harmony default export */ var global_GlobalModalManager = (GlobalModalManager);


/***/ }),

/***/ 30682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ GlobalModalType; }
/* harmony export */ });
var GlobalModalType;
(function(GlobalModalType) {
    GlobalModalType["FastOrder"] = "fastOrder";
    GlobalModalType["ChatLimit"] = "chatLimit";
})(GlobalModalType || (GlobalModalType = {}));


/***/ }),

/***/ 79928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var CloseSvg = function(param) {
    var _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _stroke = param.stroke, stroke = _stroke === void 0 ? "currentColor" : _stroke, _width = param.width, width = _width === void 0 ? "1em" : _width, _height = param.height, height = _height === void 0 ? "1em" : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 12 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11 1.5L1 11.5",
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1 1.5L11 11.5",
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CloseSvg);


/***/ }),

/***/ 16981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16165);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15746);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71230);
/* harmony import */ var global_Icons_CloseSvg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79928);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89997);








var BaseModal = function(_param) /*#__PURE__*/ {
    var prefix = _param.prefix, title = _param.title, children = _param.children, _closable = _param.closable, closable = _closable === void 0 ? true : _closable, _hideHeader = _param.hideHeader, hideHeader = _hideHeader === void 0 ? false : _hideHeader, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "prefix",
        "title",
        "children",
        "closable",
        "hideHeader"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .Modal */ .u_, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        centered: true,
        footer: null
    }, props), {
        closable: false,
        children: [
            !hideHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .HeaderRow */ .VJ, {
                className: "base-modal-header",
                align: "middle",
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        span: 1,
                        children: prefix
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        span: 22,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            align: "middle",
                            justify: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, {
                                    className: "base-modal-title",
                                    children: title
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        span: 1,
                        children: closable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .CloseButton */ .PZ, {
                            onClick: props.onCancel,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                style: {
                                    fontSize: 10,
                                    color: "#969696"
                                },
                                component: global_Icons_CloseSvg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
                            })
                        })
                    })
                ]
            }),
            children
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BaseModal);


/***/ }),

/***/ 89997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "PZ": function() { return /* binding */ CloseButton; },
/* harmony export */   "VJ": function() { return /* binding */ HeaderRow; },
/* harmony export */   "u_": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33070);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71230);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & .ant-modal-content {\n    border-radius: 3px;\n  }\n  & .ant-modal-body {\n    padding: 24px 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 22px;\n  padding: 0 20px;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 24px;\n\n  margin: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n\n  width: 24px;\n  height: 24px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-90095253-0"
})(_templateObject());
var HeaderRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-90095253-1"
})(_templateObject1());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
    componentId: "sc-90095253-2"
})(_templateObject2());
var CloseButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-90095253-3"
})(_templateObject3());


/***/ }),

/***/ 28840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ useSecuritiesStore; }
/* harmony export */ });
/* unused harmony exports securitiesState, securitiesActions */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14671);





var securitiesState = {
    channel: {},
    isReconnectionFailed: false,
    isSocketOnline: false
};
var securitiesActions = function(set) {
    return {
        setChannel: function(key, value) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.channel = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, draft.channel), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, key, value));
                });
            });
        },
        setIsReconnectionFailed: function(value) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.isReconnectionFailed = value;
                });
            });
        },
        setIsSocketOnline: function(isSocketOnline) {
            set({
                isSocketOnline: isSocketOnline
            });
        },
        resetChannel: function() {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.channel = {};
                });
            });
        }
    };
};
var useSecuritiesStore = (0,zustand__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(function(set, get, store, storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, securitiesState, securitiesActions(set, get, store, storeMutation));
});


/***/ })

}]);